var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "track-timeline-container" }, [
    _vm.timelineList && _vm.timelineList.length > 0
      ? _c(
          "ul",
          { staticClass: "timeline" },
          _vm._l(_vm.visibleList, function (item, index) {
            return _c(
              "li",
              { key: index, class: ["tl-item", { latest: index === 0 }] },
              [
                _c("span", { staticClass: "tl-dot" }),
                index === 0
                  ? _c("div", { staticClass: "card" }, [
                      _c("div", { staticClass: "row" }, [
                        _c("span", { staticClass: "tl-time" }, [
                          _vm._v(_vm._s(item.dateTime || "--")),
                        ]),
                        _c("div", { staticClass: "tl-desc" }, [
                          _c("span", [_vm._v(_vm._s(item.status || "--"))]),
                          _vm.hasPhoto(item)
                            ? _c(
                                "button",
                                {
                                  staticClass: "view-photo-btn",
                                  attrs: { type: "button" },
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return _vm.onViewPhoto(item)
                                    },
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass: "el-icon-picture-outline",
                                    staticStyle: { "margin-right": "2px" },
                                  }),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("trajectory.viewSignImage")
                                      ) +
                                      " "
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm.hasProblemPhoto(item)
                            ? _c(
                                "button",
                                {
                                  staticClass:
                                    "view-photo-btn view-problem-photo-btn",
                                  attrs: { type: "button" },
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return _vm.onViewProblemPhoto(item)
                                    },
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass: "el-icon-warning-outline",
                                    staticStyle: { "margin-right": "2px" },
                                  }),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("trajectory.viewProblemImage")
                                      ) +
                                      " "
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ]),
                        _c("span", { staticClass: "tl-op" }, [
                          _vm._v(
                            _vm._s(
                              item.operateUserName || item.siteName || "--"
                            )
                          ),
                        ]),
                        _c("span", { staticClass: "tl-loc" }, [
                          _vm._v(_vm._s(item.address || item.siteName || "--")),
                        ]),
                      ]),
                    ])
                  : _c("div", { staticClass: "row" }, [
                      _c("span", { staticClass: "tl-time" }, [
                        _vm._v(_vm._s(item.dateTime || "--")),
                      ]),
                      _c("div", { staticClass: "tl-desc" }, [
                        _c("span", [_vm._v(_vm._s(item.status || "--"))]),
                        _vm.hasPhoto(item)
                          ? _c(
                              "button",
                              {
                                staticClass: "view-photo-btn",
                                attrs: { type: "button" },
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.onViewPhoto(item)
                                  },
                                },
                              },
                              [
                                _c("i", {
                                  staticClass: "el-icon-picture-outline",
                                  staticStyle: { "margin-right": "2px" },
                                }),
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("trajectory.viewSignImage")) +
                                    " "
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm.hasProblemPhoto(item)
                          ? _c(
                              "button",
                              {
                                staticClass:
                                  "view-photo-btn view-problem-photo-btn",
                                attrs: { type: "button" },
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.onViewProblemPhoto(item)
                                  },
                                },
                              },
                              [
                                _c("i", {
                                  staticClass: "el-icon-warning-outline",
                                  staticStyle: { "margin-right": "2px" },
                                }),
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t("trajectory.viewProblemImage")
                                    ) +
                                    " "
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]),
                      _c("span", { staticClass: "tl-op" }, [
                        _vm._v(
                          _vm._s(item.operateUserName || item.siteName || "--")
                        ),
                      ]),
                      _c("span", { staticClass: "tl-loc" }, [
                        _vm._v(_vm._s(item.address || item.siteName || "--")),
                      ]),
                    ]),
              ]
            )
          }),
          0
        )
      : _vm._e(),
    _vm.timelineList.length > _vm.defaultVisibleCount
      ? _c("div", { staticClass: "more" }, [
          _c(
            "button",
            { attrs: { type: "button" }, on: { click: _vm.toggleExpand } },
            [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.isExpanded
                      ? _vm.$t("trajectory.collapseEarlier")
                      : _vm.$t("trajectory.expandEarlier")
                  ) +
                  " "
              ),
            ]
          ),
        ])
      : _vm._e(),
    !_vm.timelineList || _vm.timelineList.length === 0
      ? _c("div", { staticClass: "empty-timeline" }, [
          _c("i", {
            staticClass: "el-icon-document-delete",
            staticStyle: {
              "font-size": "28px",
              color: "#c0c4cc",
              "margin-bottom": "8px",
            },
          }),
          _c(
            "span",
            { staticStyle: { color: "#909399", "font-size": "13px" } },
            [_vm._v(_vm._s(_vm.$t("trajectory.noTrackInfo")))]
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }